import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { PageLayoutStandard } from '@shapeable/ui';

// -------- Styles -------->

const LayoutStyles = breakpoints({
  base: css`
    /* override title styles via BEM here to affect spacing */ 
    .shp--page-layout-standard__title {
      font-family: ${theme.FONT('sans')};
      font-weight: 500;
      line-height: 0.9em;
      letter-spacing: -0.03em;
      max-width: 700px;
      margin-bottom: 32px;
    }
  `,
  tablet: css`
    .shp--page-layout-standard__title {
      
    }

  `,
  desktop: css`
    
  `
});

// -------- Components -------->

const My = {
  Layout: styled(PageLayoutStandard)`${LayoutStyles}`,
};

export const PageLayoutHome: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;

  return (
    <My.Layout 
      entity={entity}
      slices={slices}
      headerProps={{ showOverlayGradient: true, variant: "overlay" }}
      className={className}
    />
  )
};
